
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const HybridWorkforcePage = lazy(() => import('../pages/hybrid-workforce/page'));
const BusinessesPage = lazy(() => import('../pages/businesses/page'));
const SolutionsPage = lazy(() => import('../pages/solutions/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/hybrid-workforce',
    element: <HybridWorkforcePage />,
  },
  {
    path: '/businesses',
    element: <BusinessesPage />,
  },
  {
    path: '/solutions',
    element: <SolutionsPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
